// src/data/pictGeo.js
// ============================================================
// Coordonnées approximatives [lng, lat] de chaque territoire
// (capitale / centroïde) pour le placement sur la carte Mapbox.
// ============================================================

const PICT_GEO = {
  AS: [-170.70, -14.30],  // American Samoa
  CK: [-159.78, -21.21],  // Cook Islands
  FJ: [178.07, -17.71],   // Fiji
  PF: [-149.43, -17.65],  // French Polynesia
  GU: [144.79, 13.44],    // Guam
  KI: [173.00, 1.45],     // Kiribati (Tarawa)
  MH: [171.18, 7.10],     // Marshall Islands
  FM: [158.22, 6.92],     // Micronesia (Pohnpei)
  NR: [166.92, -0.52],    // Nauru
  NC: [165.62, -21.30],   // New Caledonia
  NU: [-169.87, -19.05],  // Niue
  MP: [145.75, 15.18],    // Northern Mariana Islands
  PW: [134.58, 7.50],     // Palau
  PG: [144.30, -6.31],    // Papua New Guinea
  PN: [-130.10, -25.07],  // Pitcairn
  WS: [-172.10, -13.76],  // Samoa
  SB: [160.16, -9.43],    // Solomon Islands
  TK: [-171.86, -9.20],   // Tokelau
  TO: [-175.20, -21.18],  // Tonga
  TV: [179.19, -8.52],    // Tuvalu
  VU: [167.00, -15.38],   // Vanuatu
  WF: [-178.12, -14.30],  // Wallis and Futuna
};

export default PICT_GEO;